import { Inbox } from "@novu/react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

function NovuInbox() {
    const history = useHistory();
    const userId = useSelector((state: any) => state.userLogin.user?.userId);

    if (!userId) {
        history.push("/");
        return null;
    }

    const appearance = {
        elements: {
            bellIcon: {
                padding: "1px",
                color: "white",
            },
        },
        variables: {
            colorBackground: "white",
            colorPrimary: "#1990FE",
            colorForeground: "#000000",
            colorSecondaryForeground: "#000000",
            colorSecondary: "#000000",
            borderRadius: "0px",
        },
    };

    return (
        <Inbox
            applicationIdentifier={
                process.env.REACT_APP_NOVU_APPLICATION_IDENTIFIER || ""
            }
            subscriberId={userId}
            routerPush={(path: string) => history.push(path)}
            appearance={appearance}
        />
    );
}

export default NovuInbox;
